import { useOutletContext } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate, useNavigationType, useLocation } from "react-router-dom";
import NewOrder from "./New_Order";

const CustomerDashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const navigationType = useNavigationType(); // POP, PUSH, REPLACE
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const { setPageTitle } = useOutletContext();

  const no_ref = useRef(null);

  useEffect(() => {
    setPageTitle("Dashboard");
  }, [setPageTitle]);

  useEffect(() => {
    if (location.state?.flag === "show") {
      setShowLogoutModal(true);
    }
  }, []);

  useEffect(() => {
    if (navigationType === "POP") {
      // Browser Back Button
      setShowLogoutModal(false);
    }
  }, [navigationType]);

  const logout = () => {
    setShowLogoutModal(false);
    localStorage.removeItem("loginuser");
    sessionStorage.removeItem("loginuser");
    localStorage.removeItem("customerInfo");

    localStorage.removeItem("itemCategoryMaster");
    localStorage.removeItem("itemMaster");
    localStorage.removeItem("branchItemRateMaster");
    localStorage.removeItem("customerItemRateMaster");
    localStorage.removeItem("deliveryTimeSlot");
    navigate("/signin", { replace: true });
  };

  const closeModal = () => {
    setShowLogoutModal(false);
  };

  useEffect(() => {
    if (showLogoutModal) {
      setTimeout(() => {
        if (no_ref.current) {
          no_ref.current.focus();
        }
      }, 50); // small delay so modal DOM is ready
    }
  }, [showLogoutModal]);
  return (
    <>
      {/* <div className="d-flex flex-column align-items-center justify-content-center mb-3 mt-2">
        <Button
          type="submit"
          className="col-lg-2 col-md-3 col-5  btn-theme btn-md text-black"
          onClick={() => navigate("/new_order")}
        >
          <b>
            <i className="fa-solid fa-box me-2"></i>
             Order
          </b>
        </Button>
      </div> */}

      <NewOrder />

      <Modal
        show={showLogoutModal}
        onHide={closeModal}
        backdrop="static"
        keyboard={false}
      >
        <div className="bg-Modal-black">
          <Modal.Header closeButton>
            <Modal.Title className="text-theme">Logout Alert</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to logout?</Modal.Body>
          <Modal.Footer>
            <Button
              variant="danger"
              ref={no_ref}
              onClick={closeModal}
              className="no-btn"
            >
              No
            </Button>
            <Button
              variant="success"
              className="btn btn-success  "
              onClick={logout}
            >
              Yes
            </Button>
          </Modal.Footer>
        </div>
      </Modal>
    </>
  );
};
export default CustomerDashboard;
